import { PropsWithChildren } from 'react';
import { isMobile } from 'react-device-detect';
import { useUnit } from 'effector-react';

import { theme } from 'shared/styles/theme';
import { Box } from 'shared/ui/Box';
import { Icon } from 'shared/ui/Icon';
import { IconButton } from 'shared/ui/IconButton';
import { Paper } from 'shared/ui/Paper';

import { $notifications, type Notification, startExit } from '../model';

import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';

const slideIn = keyframes`
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
`;

const slideOut = keyframes`
  from {
    transform: translateX(0);
    opacity: 1;
  }
  to {
    transform: translateX(100%);
    opacity: 0;
  }
`;

const AlertStyled = styled(Paper)<{ variant: Notification['variant']; $isExiting?: boolean }>(({ variant, $isExiting }) => ({
  background: variant === 'success' ? theme.colors.green100 : theme.colors.red100,
  boxShadow: '2px 2px 0px 0px solid black',
  padding: theme.space[7],
  position: 'relative',
  height: '93px',
  alignItems: 'center',
  display: 'flex',
  animation: `${$isExiting ? slideOut : slideIn} 0.5s forwards`,
}));

const StackStyled = styled(Box)`
  gap: ${theme.space[4]};
  position: fixed;
  top: ${isMobile ? 0 : theme.space[6]};
  right: ${isMobile ? 0 : theme.space[7]};
  z-index: 100000000;
`;

export const notifyWrapperSelector = 'notify';

const NotificationItem = ({ item }: { item: Notification }) => (
  <AlertStyled className={notifyWrapperSelector} variant={item.variant} $isExiting={item.isExiting}>
    <Box position='absolute' right={theme.space[2]} top={theme.space[2]} onClick={() => startExit(item.id)}>
      <IconButton>
        <Icon name='close' />
      </IconButton>
    </Box>
    {item.message}
  </AlertStyled>
);

export const NotificationsProvider = ({ children }: PropsWithChildren<unknown>) => {
  const notifications = useUnit($notifications);

  return (
    <>
      <StackStyled>
        {notifications.map((item) => (
          <NotificationItem key={item.id} item={item} />
        ))}
      </StackStyled>
      {children}
    </>
  );
};
